import { z } from "zod";
import { personNamePartSchema } from "./person-name.js";
import { idSchema, singleLineTextSchema } from "./text.js";
// Team di un'azienda e appartenenze (piano M1a Task 9, D3, D4, D9, D11). Lo stato «invitato» non è uno
// stato dell'appartenenza: è una riga del team che rappresenta l'invito in attesa.
export const MEMBERSHIP_STATUSES = ["active", "suspending", "suspended", "archived"];
const roleSummary = z.object({ id: z.string(), name: z.string(), level: z.number().int().min(1).max(4) });
export const teamMemberSchema = z.object({
    kind: z.literal("membership"),
    membershipId: z.string(),
    /** Nome e cognome con cui la persona compare nell'azienda; `displayName` è il nome intero derivato. */
    firstName: z.string(),
    lastName: z.string(),
    displayName: z.string(),
    email: z.string(),
    role: roleSummary,
    status: z.enum(MEMBERSHIP_STATUSES),
    pendingTransition: z.enum(["suspended", "archived"]).nullable(),
    isProtectedOwner: z.boolean(),
    leadOwnerCode: z.string().nullable(),
    version: z.number().int(),
    /** La persona è nata sospesa da un'importazione da Close (INGR-15): la pagina Team lo dice con «da Close». */
    fromClose: z.boolean().optional(),
});
/** Invito in attesa (non accettato né revocato); `expiresAt` dice se va reinviato. */
export const teamInvitationSchema = z.object({
    kind: z.literal("invitation"),
    invitationId: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    displayName: z.string(),
    email: z.string(),
    role: roleSummary,
    status: z.literal("invited"),
    isProtectedOwner: z.boolean(),
    expiresAt: z.iso.datetime(),
    /** Quando l'invito è stato creato: il Team scrive «invito del {data}». */
    createdAt: z.iso.datetime(),
});
export const teamRowSchema = z.discriminatedUnion("kind", [teamMemberSchema, teamInvitationSchema]);
export const teamResponseSchema = z.object({ team: z.array(teamRowSchema) });
/**
 * Corpo di `PATCH /api/memberships/:id`: almeno un campo; `leadOwnerCode: null` lo toglie. Nome e cognome si possono
 * mandare anche uno solo: il nome intero si ricalcola dai valori salvati.
 */
export const updateMembershipBodySchema = z
    .strictObject({
    firstName: personNamePartSchema.optional(),
    lastName: personNamePartSchema.optional(),
    roleId: idSchema.optional(),
    leadOwnerCode: singleLineTextSchema(64).nullable().optional(),
})
    .refine((body) => Object.values(body).some((value) => value !== undefined), { message: "At least one field is required" });
export const membershipResponseSchema = z.object({ membership: teamMemberSchema });
//# sourceMappingURL=memberships.js.map